import React from 'react';
import { Helmet } from 'react-helmet';
import Zero2ExportHero from "../../components/zero2export/Zero2ExportHero";
import Zero2ExportCurriculum from "../../components/zero2export/Zero2ExportCurriculum";
import Zero2ExportPackage from "../../components/zero2export/Zero2ExportPackage";
import Zero2ExportBCEM from "../../components/zero2export/Zero2ExportBCEM";
import Zero2ExportTestimonies from "../../components/zero2export/Zero2ExportTestimonies";
import Zero2ExportFAQs from "../../components/zero2export/Zero2ExportFAQs";
import Alumni from '../../components/assets/Alumni.jpg';

const Zero2Export = () => {
  const pageTitle = "Zero2Export™ | Go from Beginner to Professional Exporter";
  const pageDescription = "Transform from beginner to professional exporter with our intensive 2-day training. Learn export procedures, documentation, and market access strategies. Leverage this opportunity to earn our Basic Certificate in Export Management, BCEM.";
  const canonicalUrl = "https://lsem.org.ng/zero2export";
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* React Helmet for SEO tags */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={Alumni} />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={canonicalUrl} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={Alumni} />
        
        {/* Canonical URL */}
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <Zero2ExportHero />
      <Zero2ExportCurriculum />
      <Zero2ExportPackage />
      <Zero2ExportBCEM />
      <Zero2ExportTestimonies />
      <Zero2ExportFAQs />
    </div>
  );
};

export default Zero2Export;